"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDayJSTime = exports.formatDayJSDate = exports.formatMuiDate = exports.formatTime = exports.formatDate = void 0;
exports.dateTimeToGBDate = dateTimeToGBDate;
exports.dateToString = dateToString;
exports.eventrDateTimeDifference = eventrDateTimeDifference;
const commonUtils_1 = require("../commonUtils");
const date_1 = require("./date");
const formatDate = (date, zoneType, languageLocal) => {
    if (date) {
        try {
            const newDate = new date_1.EventrDate(date);
            if (newDate.isValid) {
                switch (zoneType) {
                    case 'userLocal':
                        return newDate.toUserLocalStyledLongDateString(languageLocal ?? 'en-GB');
                    case 'itinLocal':
                        return newDate.toItinLocalStyledLongDateString(languageLocal ?? 'en-GB');
                    default: {
                        return newDate.toItinLocalStyledLongDateString(languageLocal ?? 'en-GB');
                    }
                }
            }
            else {
                return 'TBD';
            }
        }
        catch {
            (0, commonUtils_1.spLogTags)('Invalid date recieved: ' + date, ['eventrdate']);
            return 'TBD';
        }
    }
    else {
        return 'TBD';
    }
};
exports.formatDate = formatDate;
/**
 * takes time as EventrDate
 * @param timeFormat 'HH:mm' default
 */
const formatTime = (time, zoneType, timeFormat = 'HH:mm') => {
    if (time) {
        try {
            const date = new date_1.EventrDate(time);
            if (date.isValid) {
                switch (zoneType) {
                    case 'userLocal':
                        return date.userLocalLuxon.toFormat(timeFormat);
                    case 'itinLocal':
                        return date.itinLocalLuxon.toFormat(timeFormat);
                    default: {
                        return date.itinLocalLuxon.toFormat(timeFormat);
                    }
                }
            }
            else {
                return 'TBD';
            }
        }
        catch {
            (0, commonUtils_1.spLogTags)('Invalid date recieved: ' + time, ['eventrdate']);
            return 'TBD';
        }
    }
    else {
        return 'TBD';
    }
};
exports.formatTime = formatTime;
const formatMuiDate = (date) => {
    const dateString = `${date.$y}-${date.$M + 1}-${date.$D}T${date.$H}:${date.$m}`;
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const [hour, minute] = timePart.split(':');
    const formattedTime = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate}T${formattedTime}`;
    return formattedDateTime;
};
exports.formatMuiDate = formatMuiDate;
const formatDayJSDate = (date) => {
    const dateString = `${date.$y}-${date.$M + 1}-${date.$D}T${date.$H}:${date.$m}`;
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    return formattedDate;
};
exports.formatDayJSDate = formatDayJSDate;
const formatDayJSTime = (date) => {
    const dateString = `${date.$y}-${date.$M + 1}-${date.$D}T${date.$H}:${date.$m}`;
    const [datePart, timePart] = dateString.split('T');
    const [hour, minute] = timePart.split(':');
    const formattedTime = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    return formattedTime;
};
exports.formatDayJSTime = formatDayJSTime;
function dateTimeToGBDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}
/**
 * @description Takes a js date object
 * @deprecated DO NOT USE I BROKE
 * @returns string in the format "YYYY-MM-DDTHH:mm+00:00{O/N}" where O signifies an overrided timezone which shouldn't be chnaged, whereas N signifies the local timezone and can be updated to match the location.
 */
function dateToString(date, overrided, timezoneOffset) {
    const timeZoneMinutes = timezoneOffset
        ? Math.abs(timezoneOffset % 60)
        : Math.abs(date.getTimezoneOffset() % 60);
    const timezone = timezoneOffset || timezoneOffset === 0
        ? (timezoneOffset > 0 ? '-' : '+') +
            ('0' + Math.floor(Math.abs(timezoneOffset / 60)).toString()).slice(-2) +
            ':' +
            ('0' + timeZoneMinutes).slice(-2)
        : (date.getTimezoneOffset() > 0 ? '-' : '+') +
            ('0' +
                Math.floor(Math.abs(date.getTimezoneOffset() / 60)).toString()).slice(-2) +
            ':' +
            ('0' + timeZoneMinutes).slice(-2);
    if (timezoneOffset) {
        return null;
    }
    else {
        return (date.getFullYear() +
            '-' +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + date.getDate()).slice(-2) +
            'T' +
            ('0' + date.getHours()).slice(-2) +
            ':' +
            ('0' + date.getMinutes()).slice(-2) +
            timezone +
            (overrided ? 'O' : 'N'));
    }
}
/**
 * @description Takes a js date object
 * @deprecated idk if it still works. worth double chcecking it still does as expected.
 * @returns string in the format "YYYY-MM-DDTHH:mm+00:00{O/N}" where O signifies an overrided timezone which shouldn't be chnaged, whereas N signifies the local timezone and can be updated to match the location.
 */
function eventrDateTimeDifference(date1, date2) {
    const unixDiff = date1.getUnixMs - date2.getUnixMs;
    const totalMins = Math.abs(unixDiff) / 1000 / 60;
    const hourDiff = Math.floor(totalMins / 60);
    const minDiff = totalMins % 60;
    if (hourDiff > 24) {
        const dayDiff = Math.floor(hourDiff / 24);
        const hoursRemainder = hourDiff % 24;
        return (dayDiff.toString() +
            'd ' +
            hoursRemainder.toString() +
            'h ' +
            ('0' + minDiff.toString()).slice(-2) +
            'm');
    }
    else if (hourDiff > 0) {
        return (hourDiff.toString() +
            'h ' +
            ('0' + minDiff.toString()).slice(-2) +
            'm');
    }
    else {
        return minDiff.toString() + ' min';
    }
}
